import React from "react";

export default function VideoPlayer({
  selectedVideo,
  onPrev,
  onNext,
  hasPrev,
  hasNext,
}) {
  const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

  if (!selectedVideo) {
    return (
      <div className="card video-player">
        <h3>Guest Speaker Video Player</h3>
        <p>Select a video from the list to start watching.</p>
      </div>
    );
  }

  const isYouTube =
    (selectedVideo.videoType === "youtube" ||
      selectedVideo.videoType === "youtube_live") &&
    selectedVideo.youtubeId;

  const uploadedVideoSrc =
    selectedVideo.videoType === "upload" && selectedVideo.videoPath
      ? `${API_URL}${selectedVideo.videoPath}`
      : "";

  return (
    <div className="card video-player">
      <h3>
        {selectedVideo.title}{" "}
        {selectedVideo.videoType === "youtube_live" && (
          <span className="admin-badge approved">LIVE</span>
        )}
      </h3>

      <p className="video-meta">
        <strong>Speaker:</strong> {selectedVideo.speaker}
      </p>

      <p className="video-meta">
        <strong>Date:</strong>{" "}
        {selectedVideo.date
          ? new Date(selectedVideo.date + "T00:00:00").toLocaleDateString()
          : ""}
      </p>

      <p className="video-meta">
        <strong>Source:</strong>{" "}
        {selectedVideo.videoType === "youtube_live"
          ? "YouTube Live"
          : selectedVideo.videoType === "youtube"
          ? "YouTube"
          : "Uploaded Video"}
      </p>

      {selectedVideo.description && <p>{selectedVideo.description}</p>}

      <div className="section-spacing">
        {isYouTube ? (
          <div className="video-embed-wrap">
            <iframe
              className="video-embed-frame"
              src={`https://www.youtube.com/embed/${selectedVideo.youtubeId}`}
              title={selectedVideo.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        ) : (
          <video key={selectedVideo._id} controls preload="metadata" playsInline>
            <source src={uploadedVideoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}
      </div>

      <div className="video-controls">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onPrev}
          disabled={!hasPrev}
        >
          Previous
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={onNext}
          disabled={!hasNext}
        >
          Next
        </button>
      </div>
    </div>
  );
}